<template>
  <div v-if="auth == 'loggedin' || token != null || token != undefined">
    <!-- ---------- KERESÉS ---------- -->
    <b-card
      border-variant="secondary"
      class="mt-1">
      <b-card-body>
        <b-row>
          <b-col class="col-sm-12 mt-2" style="text-align: center !important;">
            <h2 class="h3ertekesites1">Értékesítés szerkesztése</h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-sm-11">
              <div class="row">

                <div v-if="userType=='admin' || userType=='user'" class="col-sm-4">
                  <!-- // NEW -->
                  <!-- <b-button
                    size="sm"
                    variant="primary"
                    class="btn float-left"
                    @click="$router.push({ name: 'CikkekNew' })"
                    ><b-icon-plus-circle></b-icon-plus-circle>
                    Új cikk hozzáadása
                  </b-button> -->
                </div>

                <!-- // SEARCH INPUT -->
                <!-- <div>
                  <b-button-group>
                    <b-button
                      size="sm"
                      class="btn float-left"
                      variant="outline-danger"
                      @click="searchText='', filterSelect='', search()"
                      ><b-icon-x-circle></b-icon-x-circle>
                    </b-button>

                    <b-form-select
                      size="sm"
                      v-model="filterSelect"
                      :options="filters"
                      class="form-control"
                      id="td"
                    ></b-form-select>
                  </b-button-group>
                </div> -->

                <div class="col-sm-4">
                  <b-form-input
                    size="sm"
                    class="form-control"
                    ref="searchInput"
                    v-model="searchText"
                    id="search"
                    @click="searchText=''"
                    @keyup.enter="search('1')"
                    autofocus
                    placeholder="terméknév, vonalkod, cikkszám"
                  ></b-form-input>
                </div>
                <div>
                  <b-button
                    size="sm"
                    class="btn float-left"
                    variant="success"
                    @click="search('1')"
                    ><b-icon-search></b-icon-search>
                    Keresés
                  </b-button>
                </div>
              </div>
          </b-col>
          <b-col class="col-sm-1" v-if="userType=='admin'">
            <b-button
              size="sm"
              class="btn float-right showbtn"
              variant="outline-primary"
              @click="showNetto()"
              ><b-icon-eye></b-icon-eye>
            </b-button>
          </b-col>

        </b-row>

      </b-card-body>
    </b-card>
    <!-- ---------- KERESÉS VÉGE ---------- -->

    <!-- ---------- TÉTEL HOZZÁADÁSA FELÜLET ---------- -->
    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <b-row>
        <b-col class="col-sm-11">
          <div>
            <label for="forras" class="float-left">Megnevezés*</label>
            <vue-typeahead-bootstrap
              :maxMatches="100"
              class="text-left"
              :minMatchingChars="1"
              ref="megnevezes_typeahead"
              size="sm"
              :data="cikkekList"
              :serializer="item => `${item.nev} - vonalkód: ${item.vonalkod} - cikkszám: ${item.cikkszam} -  készlet: ${item.mennyiseg} -  fogyár: ${item.bruttofogyar} Ft`"
              @hit="cikkSelect = $event"
              placeholder="terméknév, vonalkod, cikkszám"
              />
          </div>
        </b-col>
        <b-col class="col-sm-1">
          <b-form-group style="color: white;" label="." label-for="hozzáadása"  label-align-sm="left">
            <b-button
              size="sm"
              variant="outline-danger"
              class="btn float-left"
              @click="clearFejtetel"
              ><b-icon-x-circle></b-icon-x-circle>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-form-group label="Műveletek" label-for="hozzáadása"  label-align-sm="left">
            <b-button
              size="sm"
              variant="primary"
              class="btn float-left"
              @click="addFejtetel"
              ><b-icon-plus-circle></b-icon-plus-circle>
              Hozzáadása
            </b-button>
          </b-form-group>
        </b-col>
        <b-col class="col-sm-3">
          <div>
            <!-- <v-select
              label="nev"
              :options="cikkekList"
              model="cikkSelect"
            ></v-select> -->
            <!-- <label for="forras">Megnevezés</label>
            <v-select
              ref="forras"
              :loading="cikkekList.length <= 0"
              v-model="cikkSelect"
              :options="cikkekList"
              key="id"
              label="nev"
              @input="onInput"
              placeholder="Keresés vonalkod, terméknév">
              <template #spinner="{ loading }">
                <div v-if="loading" class="vs__spinner" />
              </template>
            </v-select> -->
            <!-- <label for="forras">Megnevezés</label>
            <vue-typeahead-bootstrap
              size="sm"
              ref="forras"
              :data="cikkekList"
              :serializer="item => item.nev"
              @hit="cikkSelect = $event"
              @keyup.enter="fillCikkData"
              placeholder="Keresés vonalkod, terméknév"
              /> -->
          </div>

        </b-col>

        <b-col>
          <b-form-group label="Mennyiség" label-for="darab"  label-align-sm="left">
            <b-form-input size="sm" type="number"
            @keyup="getVegOsszeg"
            @keyup.enter="addFejtetel"
            v-model="cikkTemp.darab" class="form-control" id="darab"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Egységár" label-for="bruttofogyar"  label-align-sm="left">
            <b-form-input size="sm" type="number" @keyup="getVegOsszeg" v-model="cikkTemp.bruttofogyar" class="form-control" id="bruttofogyar"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Összesen" label-for="sorosszesen"  label-align-sm="left">
            <b-form-input
            size="sm"
            type="number"
            v-model="cikkTemp.sorosszesen"
            class="form-control"
            id="sorosszesen"
            disabled></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Vonalkód" label-for="vonalkod"  label-align-sm="left">
            <b-form-input
            size="sm"
            type="text"
            v-model="cikkTemp.vonalkod"
            class="form-control"
            id="vonalkod"
            disabled></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Cikkszám" label-for="cikkszam"  label-align-sm="left">
            <b-form-input
            size="sm"
            type="text"
            v-model="cikkTemp.cikkszam"
            class="form-control"
            id="cikkszam"
            disabled></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Készleten" label-for="keszleten"  label-align-sm="left">
            <b-form-input
            size="sm"
            type="text"
            v-model="cikkTemp.keszleten"
            class="form-control"
            id="keszleten"
            disabled></b-form-input>
          </b-form-group>
        </b-col>

        <b-col :hidden="beszArShow == 0">
          <b-form-group label="Nettó be.ár" label-for="nettobeszar"  label-align-sm="left">
            <b-form-input  disabled size="sm" type="number" step="0.01" @keyup="getVegOsszeg" v-model="cikkTemp.nettobeszar" class="form-control" id="nettobeszar"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- <b-row>
        <h4>forrasSelect</h4>
        {{forrasSelect}}
      </b-row>
      <b-row>
        <h4>keszletFej</h4>
        {{keszletFej}}
      </b-row>
      <b-row>
        <h4>cikkSelect</h4>
        {{cikkSelect}}
      </b-row>
      <b-row>
        <h4>cikkTemp</h4>
        {{cikkTemp}}
      </b-row>
      <b-row>
        <h4>keszletTetel</h4>
        {{keszletTetel}}
      </b-row> -->
      <!-- <b-row>
        | cikkekList
        {{cikkekList}}
      </b-row> -->
    </b-card>
    <!-- ---------- TÉTEL HOZZÁADÁSA FELÜLET VÉGE ---------- -->

    <!-- ---------- TÁBLA ---------- -->
    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <!-- // TABLE -->
      <div class="mt-3">
        <b-table class="labelsize table-striped" hover :items="keszletTetel" :fields="fields" :key="keszletTetel.cikkid">

          <!-- // MENNYISÉG -->
          <template v-slot:cell(darab)="row" class="mb-1">
              <b-button
                size="sm"
                @click="getMinus(row)"
                variant="primary"
                class="mr-1"
                ><b-icon-dash>-</b-icon-dash>
              </b-button>
              {{row.item.darab}}
              <b-button
                size="sm"
                @click="getPlus(row)"
                variant="primary"
                class="mr-1"
                ><b-icon-plus></b-icon-plus>
              </b-button>
          </template>

          <!-- // NETTÓ BESZÁR -->
          <template v-slot:cell(nettobeszar)="row">
            <p v-show="beszArShow=='1'">{{row.item.nettobeszar}}</p>
          </template>

          <!-- // EDIT -->
          <template v-if="userType=='admin'" v-slot:cell(edit)="row">
            <b-button
              v-b-modal.edit-product
              size="sm"
              @click="bevMode = 2, itemId = row.item.cikkid"
              variant="outline-success"
              class="mr-1"
              ><b-icon-pencil></b-icon-pencil>
            </b-button>
          </template>

          <!-- // DELETE -->
          <template v-slot:cell(del)="row">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>

        </b-table>
      </div>
    </b-card>
    <!-- ---------- TÁBLA VÉGE ---------- -->

    <!-- ---------- VÉGÖSSZEG ---------- -->
    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <b-row>
        <b-col col lg="10">
          <h6 class="h2bevetelzes summaR">
            Nettó:
          </h6>
          <h6 class="h2bevetelzes summaR">
            Áfa:
          </h6>
          <h2 class="h2bevetelzes summaR">
            Végösszeg:
          </h2>
        </b-col>
        <b-col col lg="2">
          <h6 class="h2bevetelzes summaL">
            {{summaNetto}} Ft
          </h6>
          <h6 class="h2bevetelzes summaL">
            {{summaAFA}} Ft
          </h6>
          <h2 class="h2bevetelzes summaL">
            {{summa}} Ft
          </h2>
        </b-col>
      </b-row>
    </b-card>
    <!-- ---------- VÉGÖSSZEG VÉGE ---------- -->

    <!-- ---------- VEVŐ ADATOK ---------- -->
    <b-row>
      <b-col>
          <b-card
            border-variant="secondary"
            class="text-center mt-1">
            <b-card-body class="text-left">
              <h3 class="h3ertekesites">Vevő adatok</h3>
              <b-row>
                <!-- PARTNER -->
                <b-col>
                  <div>
                    <label for="forras">Név * </label>
                    <b-button-group>
                      <vue-typeahead-bootstrap
                        :maxMatches="100"
                        :minMatchingChars="1"
                        class="partnerInput text-left"
                        :disabled="isDisabled == 1"
                        size="sm"
                        :data="forrasList"
                        v-model="forrasSelect.nev"
                        :serializer="item => item.nev"
                        @hit="forrasSelect = $event"
                        @keyup="saveToStore"
                        placeholder="Keresés, partner neve"
                        />
                      <b-button
                        size="sm"
                        class="btn float-right"
                        variant="outline-danger"
                        @click="partnerChange()"
                        ><b-icon-x-circle></b-icon-x-circle>
                      </b-button>
                    </b-button-group>
                  </div>
                </b-col>

                <!-- Telefon -->
                <b-col>
                  <div>
                    <label for="telefon">Telefon</label>
                    <b-form-input
                      @keyup="saveToStore"
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.telefon"
                      size="sm"
                      id="telefon">
                    </b-form-input>
                  </div>
                </b-col>
                <!-- Email -->
                <b-col>
                  <div>
                    <label for="email">Email</label>
                    <b-form-input
                      @keyup="saveToStore"
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.email"
                      size="sm"
                      id="email">
                    </b-form-input>
                  </div>
                </b-col>
                <!-- VÁROS -->
                <b-col>
                  <div>
                    <label for="varos">Város</label>
                    <b-form-input
                      @keyup="saveToStore"
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.varos"
                      size="sm"
                      id="varos">
                    </b-form-input>
                  </div>
                </b-col>
                <!-- IRSZÁM -->
                <b-col>
                  <div>
                    <label for="irszam">Irányítószám</label>
                    <b-form-input
                      @keyup="saveToStore"
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.irszam"
                      size="sm"
                      id="irszam">
                    </b-form-input>
                  </div>
                </b-col>
                <!-- Cím -->
                <b-col>
                  <div>
                    <label for="cim">Cím</label>
                    <b-form-input
                      @keyup="saveToStore"
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.cim"
                      size="sm"
                      id="cim">
                    </b-form-input>
                  </div>
                </b-col>
                <!-- Adószám -->
                <b-col>
                  <div>
                    <label for="adoszam">Adószám</label>
                    <b-form-input
                      @keyup="saveToStore"
                      :disabled="isDisabled == 1"
                      v-model="forrasSelect.adoszam"
                      size="sm"
                      id="adoszam">
                    </b-form-input>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
      </b-col>
    </b-row>
    <!-- ---------- VEVŐ ADATOK VÉGE ---------- -->

    <!-- ---------- FOOTER ---------- -->
    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <b-row>
        <b-col>
          <!-- // SAVE -->
          <b-button
            variant="primary"
            @click='keszletSave'
            type="submit"
            class="float-left">
            <b-icon-cloud-upload></b-icon-cloud-upload>
            Értékesítés mentése
          </b-button>
        </b-col>
        <b-col>
          <!-- // CANCEL -->
          <b-button
            variant="outline-danger"
            class="float-right"
            @click="clearPage"
            ><b-icon-arrow-left></b-icon-arrow-left>
            Mégsem
            </b-button>
        </b-col>
      </b-row>
    </b-card>
    <!-- ---------- FOOTER VÉGE ---------- -->

    <b-modal id="edit-product" size="xl" title="" hide-footer hide-header>
      <CikkekNew :bevmode="bevMode" :itemId="itemId" @edit-product="editProduct" @close-product="closeProduct"/>
    </b-modal>


  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import {debounce} from 'lodash'

export default {
  components: {
    CikkekNew: () => import('./CikkekNew')
  },
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      proba: ['aaa', 'bbb', 'ccc'],
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      cikkShow: true,
      list: [],
      keszletFej: {
        beszerzesDatum: '',
        beszallitoId: '',
        raktarId: '',
        bizszam: ''
      },
      keszletTetel: [],
      forrasSelect: {
        id: '',
        nev: '',
        irszam: null,
        varos: '',
        cim: '',
        telefon: '',
        email: '',
        kategoria: '',
        adoszam: ''
      },
      forrasList: [],
      query: '',
      raktarSelect: [],
      raktarList: [],
      cikkekList: [],
      cikkSelect: [],
      cikkTemp: {
        cikkid: '',
        nev: '',
        sorosszesen: '',
        nettobeszar1: '',
        bruttofogyar: '',
        darab: '',
        vonalkod: '',
        cikkszam: '',
        keszleten: ''
      },
      searchText: '',
      filterSelect: '',
      isDisabled: 0,
      beszArShow: 0,
      bizszam: '',
      filters: [
        'Minden oszlop',
        'Megnevezés'
      ],
      fields: [
        // {
        //   key: 'createdAt',
        //   formatter: (value, key, item) => {
        //     return moment(String(value)).format('YYYY-MM-DD')
        //   }
        // },
        {
          key: 'nev',
          label: 'Megnevezés',
          sortable: true,
          sortDirection: 'desc',
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'darab',
          label: 'Mennyiség',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        {
          key: 'bruttofogyar',
          label: 'Egységár',
          sortable: true,
          sortDirection: 'desc',
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'osszesen',
          label: 'Összesen',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        {
          key: 'vonalkod',
          label: 'Vonalkód',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        {
          key: 'cikkszam',
          label: 'Cikkszám',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        {
          key: 'keszleten',
          label: 'Készleten',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        {
          key: 'osszesen',
          label: 'Összesen',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        // { key: 'send', sortable: false },
        // { key: 'munkalap', sortable: false },
        // { key: 'edit', sortable: false },
        {
          key: 'nettobeszar',
          label: '',
          thClass: 'text-right'
        },
        { key: 'edit',
          label: '',
          sortable: false
        },
        { key: 'del',
          label: '',
          sortable: false
        }
      ],
      summaNetto: 0,
      summaAFA: 0,
      summa: 0,
      bevMode: 0,
      itemId: 0,
      newProduct: ''
    }
  },
  methods: {
    closeProduct: function (data) {
      this.bevMode = 0
    },
    editProduct: function (data) {
      this.loadList()
      this.newProduct = data
      for (var index in this.keszletTetel) {
        if (this.keszletTetel[index].cikkid === data.id) {
          this.keszletTetel[index].bruttofogyar = this.newProduct.bruttofogyar
          this.keszletTetel[index].cikkszam = this.newProduct.cikkszam
          this.keszletTetel[index].keszleten = this.newProduct.mennyiseg
          this.keszletTetel[index].nettobeszar = this.newProduct.nettobeszar
          this.keszletTetel[index].nev = this.newProduct.nev
          this.keszletTetel[index].vonalkod = this.newProduct.vonalkod
          this.keszletTetel[index].osszesen = parseInt(this.keszletTetel[index].bruttofogyar) * parseInt(this.keszletTetel[index].darab)
          this.getSumma()
        }
      }
      this.$bvModal.hide('edit-product')
      this.clearFejtetel()
      this.bevMode = 0
      // this.$refs.megnevezes_typeahead.inputValue = this.newProduct.nev + ' - vonalkód: ' + this.newProduct.vonalkod + ' - cikkszám: ' + this.newProduct.cikkszam + ' -  készlet: ' + this.newProduct.mennyiseg + ' -  fogyár: ' + this.newProduct.bruttofogyar + ' Ft'
      // this.$refs.mennyiseg.focus()
    },

    saveToStore () {
      localStorage.setItem('forrasSelect', JSON.stringify(this.forrasSelect))
    },
    clearPage () {
      localStorage.removeItem('keszletTetel')
      localStorage.removeItem('forrasSelect')
      router.push({ name: 'Ertekesites' })
    },
    getMinus (e) {
      let index = e.index
      if (parseInt(this.keszletTetel[index].darab) === 1) {
        this.flashMessage.error({ title: 'Figyelem!', message: 'A darambszám nem lehet nullánál kisebb!!' })
      } else {
        this.keszletTetel[index].darab = parseInt(this.keszletTetel[index].darab) - 1
        this.keszletTetel[index].osszesen = parseInt(this.keszletTetel[index].bruttofogyar) * parseInt(this.keszletTetel[index].darab)
        this.getSumma()
      }
    },
    getPlus (e) {
      let index = e.index
      if (parseInt(this.keszletTetel[index].darab) === parseInt(this.keszletTetel[index].keszleten)) {
        this.flashMessage.error({ title: 'Figyelem!', message: 'Az eladható készlet kifogyott!' })
      } else {
        this.keszletTetel[index].darab = parseInt(this.keszletTetel[index].darab) + 1
        this.keszletTetel[index].osszesen = parseInt(this.keszletTetel[index].bruttofogyar) * parseInt(this.keszletTetel[index].darab)
        this.getSumma()
      }
    },
    showNetto () {
      if (this.beszArShow === 0) {
        this.beszArShow = 1
      } else {
        this.beszArShow = 0
      }
    },
    partnerChange () {
      this.isDisabled = 0
      this.forrasSelect.id = ''
      this.forrasSelect.nev = ''
      this.forrasSelect.irszam = ''
      this.forrasSelect.varos = ''
      this.forrasSelect.cim = ''
      this.forrasSelect.telefon = ''
      this.forrasSelect.email = ''
      this.forrasSelect.kategoria = ''
      this.forrasSelect.adoszam = ''
      localStorage.removeItem('forrasSelect')
    },
    onInput () {
      console.log(this.selected)
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        // Beszerzési források
        axios.post(process.env.ROOT_API + '/partner/getlist', {payload}).then((res) => {
          this.forrasList = res.data
        }).catch((err) => {
          console.log(err)
        })
        // Raktárak
        axios.post(process.env.ROOT_API + '/raktarak/getlist', {payload}).then((res) => {
          for (var el in res.data) {
            this.raktarList.push(
              {
                value: res.data[el],
                text: res.data[el].megnevezes
              })
          }
        }).catch((err) => {
          console.log(err)
        })
        // Cikkek
        axios.post(process.env.ROOT_API + '/cikkek/getquicksearchlist', {payload}).then((res) => {
          this.cikkekList = res.data
          // for (var el in res.data) {
          //   this.cikkekList.push(
          //     {
          //       value: res.data[el],
          //       text: res.data[el].nev
          //     }
          //   )
          // }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    addFejtetel () {
      let res = {}

      if (this.cikkSelect.id) {
        res.data = [{
          cikkid: this.cikkTemp.cikkid,
          nev: this.cikkTemp.nev,
          sorosszesen: this.cikkTemp.sorosszesen,
          nettobeszar: this.cikkTemp.nettobeszar,
          bruttofogyar: this.cikkTemp.bruttofogyar,
          osszesen: this.cikkTemp.sorosszesen,
          darab: this.cikkTemp.darab,
          vonalkod: this.cikkTemp.vonalkod,
          cikkszam: this.cikkTemp.cikkszam,
          keszleten: this.cikkTemp.keszleten
        }]

        const finder = (req) => {
          for (let el in req) {
            if (req[el].cikkid === res.data[0].cikkid) return req[el]
          }
        }

        let obj = finder(this.keszletTetel)

        if (obj) {
          if (parseInt(obj.darab) < parseInt(obj.keszleten)) {
            obj.darab = parseInt(obj.darab) + parseInt(res.data[0].darab)
            obj.osszesen = parseInt(obj.darab) * parseInt(obj.bruttofogyar)
          } else {
            this.flashMessage.error({ title: 'Figyelem!', message: 'Az eladható készlet kifogyott 1 !' })
          }
        } else {
          if (parseInt(res.data[0].keszleten) === 0) {
            this.flashMessage.error({ title: 'Figyelem!', message: 'Az eladható készlet kifogyott 2 !' })
          } else {
            this.keszletTetel.push(res.data[0])
          }
        }
      }

      this.cikkTemp = {
        cikkid: '',
        nev: '',
        sorosszesen: '',
        nettobeszar: '',
        bruttofogyar: '',
        darab: '',
        vonalkod: '',
        cikkszam: '',
        keszleten: ''
      }
      this.cikkSelect = []
      this.$refs.megnevezes_typeahead.inputValue = ''
      this.$refs.searchInput.focus()
      // this.$refs.forras.inputValue = ''
      // this.$refs.forras.open = false
    },
    clearFejtetel () {
      this.$refs.megnevezes_typeahead.inputValue = ''
      this.cikkTemp = {
        cikkid: '',
        nev: '',
        sorosszesen: '',
        nettobeszar: '',
        bruttofogyar: '',
        darab: '',
        vonalkod: '',
        cikkszam: '',
        keszleten: ''
      }
    },
    search (db) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if (this.searchText !== '') {
          payload.token = this.token
          payload.userType = this.userType
          payload.filter = this.filterSelect
          payload.searchText = this.searchText
          axios.post(process.env.ROOT_API + '/cikkek/search', {payload})
            .then(res => {
              res.data[0].cikkid = res.data[0].id
              res.data[0].darab = db
              res.data[0].keszleten = res.data[0].mennyiseg
              res.data[0].osszesen = res.data[0].bruttofogyar
              res.data[0].sorosszesen = res.data[0].bruttofogyar
              delete res.data[0].order
              delete res.data[0].gyariszamos
              delete res.data[0].gyartoid
              delete res.data[0].hidden
              delete res.data[0].mennyiseg
              delete res.data[0].mennyisegiegyseg
              delete res.data[0].updatedAt
              delete res.data[0].id
              delete res.data[0].closed
              delete res.data[0].createdAt
              delete res.data[0].csikcsoportid
              this.getVegOsszeg()

              const finder = (req) => {
                for (let el in req) {
                  if (req[el].cikkid === res.data[0].cikkid) return req[el]
                }
              }

              let obj = finder(this.keszletTetel)

              if (obj) {
                if (parseInt(obj.darab) < parseInt(obj.keszleten)) {
                  obj.darab = parseInt(obj.darab) + 1
                  obj.osszesen = parseInt(obj.darab) * parseInt(obj.bruttofogyar)
                } else {
                  this.flashMessage.error({ title: 'Figyelem!', message: 'Az eladható készlet kifogyott!' })
                }
              } else {
                if (parseInt(res.data[0].keszleten) === 0) {
                  this.flashMessage.error({ title: 'Figyelem!', message: 'Az eladható készlet kifogyott!' })
                } else {
                  this.keszletTetel.push(res.data[0])
                }
              }
              this.getSumma()
              this.searchText = ''
              this.$refs.searchInput.focus()
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    },
    keszletSave () {
      let payload = {}
      let biancoPertnerMode = false
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if (!this.forrasSelect.nev) { biancoPertnerMode = true }
        if (this.keszletTetel.length > 0) {
          payload.token = this.token
          payload.userType = this.userType
          payload.forrasSelect = this.forrasSelect
          payload.biancoPertnerMode = biancoPertnerMode
          payload.keszletFej = this.keszletFej
          payload.keszletTetel = this.keszletTetel
          payload.summa = this.summa
          axios
            .post(process.env.ROOT_API + '/ertekesites/save', { payload })
            .then(res => {
              this.$router.push({ name: 'Ertekesites' })
              this.flashMessage.success({ title: 'Gratulálunk!', message: 'Az adatokkat sikeresem mentésre kerültek!' })
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          this.flashMessage.warning({ message: 'Adj hozzás legalább egy terméket a terméklistához!' })
        }
      }
    },
    fillCikkData () {
      if (this.cikkSelect.id) {
        this.cikkTemp.cikkid = this.cikkSelect.id
        this.cikkTemp.nev = this.cikkSelect.nev
        this.cikkTemp.nettobeszar = this.cikkSelect.nettobeszar
        this.cikkTemp.bruttofogyar = this.cikkSelect.bruttofogyar
        this.cikkTemp.darab = 1
        this.cikkTemp.vonalkod = this.cikkSelect.vonalkod
        this.cikkTemp.cikkszam = this.cikkSelect.cikkszam
        this.cikkTemp.keszleten = this.cikkSelect.mennyiseg
        this.getVegOsszeg()
        // this.$refs.darab.focus()
      }
    },
    getVegOsszeg () {
      if (this.cikkTemp.keszleten >= this.cikkTemp.darab) {
        this.cikkTemp.sorosszesen = this.cikkTemp.bruttofogyar * this.cikkTemp.darab
      } else {
        this.cikkTemp.darab = this.cikkTemp.keszleten
        this.cikkTemp.sorosszesen = this.cikkTemp.bruttofogyar * this.cikkTemp.darab
      }
    },
    getSumma () {
      this.summaNetto = 0
      this.summaAFA = 0
      this.summa = 0
      for (let el in this.keszletTetel) {
        this.summa += parseInt(this.keszletTetel[el].osszesen)
      }
      this.summaNetto = Math.round(this.summa / 1.27)
      this.summaAFA = Math.round(this.summa - this.summaNetto)
    },
    showMsgBoxTwo (row) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('(Megnevezés:  ' + row.item.nev + ') ', {
          title: 'Biztos törlöni akarod?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.keszletTetel.splice(row.index, 1)
            // let el = this.keszletTetel.find(e => e.cikkid === id)
            // this.keszletTetel.splice(this.keszletTetel.findIndex(a => a.id === el.id), 1)
            if (this.keszletTetel.length === 0) {
              localStorage.removeItem('keszletTetel')
            } else {
              localStorage.removeItem('keszletTetel')
              localStorage.setItem('keszletTetel', JSON.stringify(this.keszletTetel))
            }
            this.getSumma()
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted: function () {
    this.loadList()
    if (JSON.parse(localStorage.getItem('keszletTetel'))) {
      this.keszletTetel = JSON.parse(localStorage.getItem('keszletTetel'))
    }
    if (JSON.parse(localStorage.getItem('forrasSelect'))) {
      this.forrasSelect = JSON.parse(localStorage.getItem('forrasSelect'))
    }
    this.getSumma()
  },
  watch: {
    cikkSelect: function () {
      this.fillCikkData()
      this.getSumma()
      localStorage.setItem('keszletTetel', JSON.stringify(this.keszletTetel))
    },
    forrasSelect: function () {
      this.isDisabled = 1
      localStorage.setItem('forrasSelect', JSON.stringify(this.forrasSelect))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ErtekesitesNew.vue